<script setup lang="ts">
  import { ref, defineProps, defineExpose } from 'vue'
  import SkeletonLoader from '@/components/skeleton/SkeletonLoader.vue'
  import ImageIcon from '@/components/icons/ImageIcon.vue'

  interface Props {
    src: string
    alt?: string
    width?: string
    height?: string
  }

  const props = defineProps<Props>()

  const loaded = ref<boolean>(false)

  const onImageLoad = () => {
    console.log('Image loaded')
    loaded.value = true
  }

  // Optional: Expose loaded state to parent
  defineExpose({
    loaded
  })
</script>

<template>
  <!-- The class prop is automatically handled by Vue and passed down -->
  <div
    v-if="!loaded"
    :class="$attrs.class"
  >
    <SkeletonLoader
      :width="props.width"
      :height="props.height"
      class="relative flex items-center justify-center bg-gray-100"
    >
      <ImageIcon class="h-6 w-6 text-gray-400" />
    </SkeletonLoader>
  </div>

  <!-- The <img> tag always exists in the DOM; visibility is toggled -->
  <img
    :src="props.src"
    @load="onImageLoad"
    :alt="props.alt"
    :style="{ display: loaded ? 'block' : 'none' }"
    :width="props.width"
    :height="props.height"
    :class="$attrs.class"
  />

  <!-- Optional slot for custom loading content -->
  <slot v-if="!loaded" />
</template>
